export default __webpack_public_path__ + "static/media/167.d0463c2f.jpg";